

// toggle the mobile nav and set aria attributes

$(document).ready(function () {

	var $body = $('body');
	var $slideNavToggle = $('.js-slide-nav-trigger');
	var $slideNavRootCheckbox = $('#slide-nav-checkbox-root');
	var $slideNavClose = $('.slide-nav-label-close');

	// Set initial aria attributes
	$slideNavToggle.attr("aria-expanded","false").attr("aria-controls","navigation-mobile");

	// Open the nav
	$slideNavToggle.on('click', function(e) {

		if ( !$('#slide-nav-checkbox-root').is( ':checked' )) {

			$slideNavRootCheckbox.prop( 'checked', true );
			$slideNavToggle.attr("aria-expanded","true").attr("aria-expanded","true");
			$body.addClass('slide-nav-is-open');
		}

	});

	// Close the nav
	$slideNavClose.on('click', function(v) {

        if ( $slideNavRootCheckbox.is( ':checked' )) {

            $body.removeClass('slide-nav-is-open');
            $slideNavToggle.attr("aria-expanded","false");
        }
    });

});



// Mobile navigation: scroll up on checkbox change

$(document).ready(function () {

	var $navCheckboxes = $('.slide-nav-checkbox');

	$navCheckboxes.on('change', function () {
		$('.slide-nav-root, .slide-nav-root *').scrollTop(0);
	});
});


